<template>
  <div>
    <span v-html="activityMessage"></span>
  </div>
</template>

<script>
export default {
  name: 'TaskModuleRulesRuleUpdated',
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activityMessage() {
      const actor = this.activity?.actorUser?.name || 'Bilinmeyen Kullanıcı';
      const workflowTitle = this.activity?.payload?.workflowTitle || 'İsimsiz İş Akışı';
      const ruleName = this.activity?.payload?.ruleName || 'İsimsiz Kural';
      
      return this.$t('notification.taskModuleRulesRuleUpdated', {
        actor: `<strong>${actor}</strong>`,
        workflowTitle: `<strong>${workflowTitle}</strong>`,
        ruleName: `<strong>${ruleName}</strong>`
      });
    }
  }
};
</script>

<style scoped>
</style>

